import React from 'react';
import PropTypes from 'prop-types';
import Img from 'gatsby-image';
import { Spring } from 'react-spring';
import * as easings from 'd3-ease';
import styles from './project-video-thumbnail.module.css';

const ProjectVideoThumbnail = ({ videoThumbnail, playVideo, isInView }) => {
  const handleClickPlay = () => {
    playVideo();
  };

  const animationConfig = {
    delay: 300,
    duration: 900,
    easing: easings.easeCubicOut,
  };

  return (
    <div className={styles.thumbnail}>
      <Spring
        from={{ opacity: 0, transform: 'scale(0.85, 0.85)' }}
        to={{
          opacity: isInView ? 1 : 0,
          transform: isInView ? 'scale(1, 1)' : 'scale(0.85, 0.85)',
        }}
        config={animationConfig}
      >
        {animation => (
          <div
            className={styles.playButton}
            onClick={handleClickPlay}
            style={animation}
          >
            <span className={styles.play}>play</span>
          </div>
        )}
      </Spring>

      <Img
        sizes={videoThumbnail.localFile.childImageSharp.sizes}
        backgroundColor={true}
        style={{
          position: 'absolute',
          left: 0,
          top: 0,
          left: 0,
          right: 0,
        }}
        className={styles.videoThumbnailImg}
      />
    </div>
  );
};

ProjectVideoThumbnail.propTypes = {
  videoThumbnail: PropTypes.object,
  playVideo: PropTypes.func,
  isInView: PropTypes.bool,
};

export default ProjectVideoThumbnail;



// WEBPACK FOOTER //
// ./src/components/project/project-video/project-video-thumbnail/index.js